/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Turkish (Turkey)
export default {
  'team-central.give-jira-kudos.created.description.flag': 'İş Yeri Deneyimi takımımız şimdi hediye talebini işleme alacak. ✨',
  'team-central.give-jira-kudos.created.title.flag': 'Tebrik oluşturuldu',
  'team-central.give-jira-kudos.creation.failed.description.flag': 'Tebrik mesajınız oluşturulamadı veya hediyeniz gönderilemedi. <a>go/kudos</a> bölümünden ayrı bir bilet oluşturmayı deneyin.',
  'team-central.give-jira-kudos.creation.failed.title.flag': 'Bir hata oluştu',
  'team-central.give-kudos.button': 'Tebrik et',
  'team-central.give-kudos.close-button.label': 'Çekmeceyi kapat',
  'team-central.give-kudos.confirm-close.title': 'Kapatmayı Onaylayın',
  'team-central.give-kudos.created.description.flag': 'Tebriğiniz gönderildi. <a>Tebriği görüntüleyin</a>',
  'team-central.give-kudos.created.title.flag': 'Tebrik mesajı oluşturuldu',
  'team-central.give-kudos.creation.failed.description.flag': 'Tebrik mesajınız oluşturulamadı.',
  'team-central.give-kudos.creation.failed.title.flag': 'Bir hata oluştu',
  'team-central.give-kudos.error-icon.label': 'Hata',
  'team-central.give-kudos.success-icon.label': 'Başarılı',
  'team-central.give-kudos.unsaved.warning': 'Yaptığınız değişiklikler kaydedilmez.',
  'team-central.give-kudos.unsaved.warning.cancel': 'İptal',
  'team-central.give-kudos.unsaved.warning.close': 'Kapat'
};